import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useGpiProductId from "./hooks/useGpiProductId";

const GpiProductId = ({
  setScreenType,
  selectParams,
  hideModal,
  lookupType,
  selectMode,
  onSelect,
  productScreenTitle,
  productScreenNumber,
  multiSelect,
}) => {
  const priceScheduleData = useGpiProductId(
    setScreenType,
    selectParams,
    hideModal,
    lookupType,
    selectMode,
    onSelect,
    productScreenTitle,
    productScreenNumber,
    multiSelect
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={priceScheduleData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {priceScheduleData.screen_title} -{" "}
          <span className="heading-cod">{priceScheduleData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={priceScheduleData.formFields}
        dropdownValues={priceScheduleData.dropdownValues}
        paramsData={priceScheduleData.paramsData}
        updataParamData={priceScheduleData.updateParamData}
      />
      <ButtonsSection ctaButtons={priceScheduleData.ctaButtons} />
      <DisplayTable
        data={priceScheduleData.data}
        parmKey={priceScheduleData.parmKey}
        menuOptions={priceScheduleData.menuOptions}
        tableHeaders={priceScheduleData.columnDef}
        setRowData={priceScheduleData.setRowData}
        selectedPriceSchedules={priceScheduleData.selectedRows}
        setSelectedPriceSchedules={priceScheduleData.setSelectedRows}
        selectMode={selectMode}
        multiSelect={multiSelect}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={priceScheduleData.first}
          rows={priceScheduleData.rows}
          totalRecords={priceScheduleData.totalRecords}
          currentPage={priceScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={priceScheduleData.onPageChange}
        />
      </div>
      {priceScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={priceScheduleData.isConfirmationModalOpen}
          onRequestClose={priceScheduleData.closeConfirmationModal}
          onBack={priceScheduleData.closeConfirmationModal}
          onSave={priceScheduleData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={priceScheduleData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default GpiProductId;
